import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n";
import Landing from "./pages/Landing";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import LegalPage from "./pages/LegalPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/privacidade" element={<LegalPage kind="privacidade" />} />
          <Route path="/cookies" element={<LegalPage kind="cookies" />} />
        </Routes>
        <Toaster position="top-center" richColors theme="dark" />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
